import React from 'react';
import { isEmptyData } from '../../../../../utils/helper';
import VoucherDetail from '../../../../../components/Voucher/VoucherDetail';
import VoucherGlobalDetail from '../../../../../components/VoucherGlobal/VoucherDetail';
import PromoCode from '../../../../../components/PromoCode';
import LoyaltyVoucher from '../../../Summary/VoucherLoyalty';
import GlobalVoucher from '../../../Summary/VoucherGlobal';
import B2BVoucher from '../../../Summary/VoucherB2B';

const VoucherBottomSheet = (props) => {
	const {
		isShowVoucher = false,
		voucherGlobalList = [],
		b2bVoucherList = [],
		loyaltyVoucherList = [],
		cart = {},
		totalOrder = null,
		showVoucherDetail = { isOpen: false, data: null, type: null },
		handleVoucherDetail = () => {},
		handleRedeemVoucherGlobal = () => {},
	} = props;
	if (!isShowVoucher) return null;

	return (
		<>
			<div className={`bg-white transition-transform duration-1000 ease-in-out rounded-t-xl h-full relative ${isShowVoucher ? 'translate-y-0 relative' : 'translate-y-full hidden'}`}>
				<div className='flex justify-start py-4 text-base text-gray-900 font-semibold mx-4'>Tambah Voucher</div>
				<div className='border-b-1 border-solid border-gray-200 mb-4' />
				<PromoCode onSubmit={(data) => handleRedeemVoucherGlobal(data)} cart={cart} totalOrder={totalOrder} />
				<div className='h-full overflow-y-scroll overflow-x-hidden scrollbar-hide '>
					<div className={`mt-4 h-full`}>
						<div className='text-base font-semibold text-gray-900 mx-4'>Voucher Saya</div>
						<GlobalVoucher {...props} />
						<LoyaltyVoucher {...props} />
						<div className={`my-8 flex flex-col items-center ${(!isEmptyData(voucherGlobalList) || !isEmptyData(loyaltyVoucherList)) && 'hidden'}`}>
							<div className='text-gray-900 font-semibold text-base'>Kamu tidak memiliki voucher</div>
							<div className='text-gray-900 font-thin text-xs'>Jangan lewatkan! Beli voucher untuk diskon</div>
						</div>
						<div className='border-b-8 border-solid pb-5 border-gray-200 w-screen' />
						<div className='text-base font-semibold text-gray-900 mt-6 mx-4'>Voucher lainnya dari UFood</div>
						<B2BVoucher {...props} />
						<div className={`my-8 flex flex-col items-center ${!isEmptyData(b2bVoucherList) && 'hidden'}`}>
							<div className='text-gray-900 font-semibold text-base'>Kamu tidak memiliki voucher</div>
							<div className='text-gray-900 font-thin text-xs'>Jangan lewatkan! Beli voucher untuk diskon</div>
						</div>
					</div>
				</div>
			</div>
			{showVoucherDetail.isOpen && isEmptyData(showVoucherDetail.type) && <VoucherDetail data={showVoucherDetail.data} onClose={() => handleVoucherDetail(false)} />}
			{showVoucherDetail.isOpen && !isEmptyData(showVoucherDetail.type) && <VoucherGlobalDetail data={showVoucherDetail.data} onClose={() => handleVoucherDetail(false)} />}
		</>
	);
};

export default VoucherBottomSheet;
